<div class="container">
    <div class="tab-bar">
        <div class="tab" [class.active]="i | equals:selectedIndex" (click)="selectTab(i)"
            *ngFor="let page of pages; let i = index">
            {{ page?.title ?? '' }}
        </div>
        <div style="flex: 1;"></div>
        <div class="navigation" (click)="_openSideNavigator()">
            <i class="fas fa-map"></i>
        </div>
        <div class="title">
           {{activeProjectId$ | async}} &nbsp; {{ _calculationDescription ?? '' }}
        </div>
    </div>
    <div class="pages">
        <div class="page" [hidden]="i | equals:selectedIndex:false" *ngFor="let page of pages; let i = index">
            <ng-container *ngTemplateOutlet="page.template"></ng-container>
        </div>
    </div>
    <div #navigatorRoot class="side-navigator" *ngIf="!!_calculationLines.value?.length"
        [@side-menu]="_sideNavigatorOpen ? 'open' : 'closed'">
        <div class="header">
            <div class="title">Navigeren</div>
            <i class="close fas fa-times" (click)="_sideNavigatorOpen = false"></i>
        </div>
        <div class="search">
            <input #navSearchInput [(ngModel)]="_navSearchText" (ngModelChange)="_searchNav()"
                (keydown.enter)="_handleEnter($event)" tabindex="-1">
            <i class="icon fas fa-search"></i>
        </div>
        <div class="content scrollable">
            <div class="category" [class.open]="_openCategories | includes: category.code"
                *ngFor="let category of _visibleCategories">
                <div class="row">
                    <i class="opener fas" [class.fa-caret-right]="_openCategories | includes: category.code | not"
                        [class.fa-caret-down]="_openCategories | includes: category.code"
                        (click)="_toggleCategoryOpen(category.code)"></i>
                    <div class="value" (click)="_scrollToCategory(category)">
                        <div class="code">{{ category.code }}</div>
                        <div class="description">{{ category.description }}</div>
                    </div>
                </div>
                <ng-container *ngIf="_openCategories | includes: category.code">
                    <div class="subcategory" *ngFor="let subcategory of category.subcategories">
                        <div class="row">
                            <div class="value" (click)="_scrollToSubcategory(subcategory)">
                                <div class="code">{{ subcategory.code }}</div>
                                <div class="description">{{ subcategory.description }}</div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>